module.exports = __webpack_public_path__ + "static/media/micpause.5b341f1d.svg";